import { CardItem } from '../components/CardItem';
import { Section } from '../components/Section';
import { informations } from '../constants/informations';

export default function OutrasInformacoes() {
  return (
    <Section>
      <h2 className="text-center fw-normal mb-4 pb-2">Outras Informações</h2>
      {informations?.map((item, index) => (
        <CardItem item={item} key={index} className="col-lg-4" />
      ))}
    </Section>
  );
}
